import { jsx as e } from "react/jsx-runtime";
import { Box as w } from "@chakra-ui/react";
import { m as y, n as D, o as I } from "../../../floating-ui.react-5e63cf1f.js";
import { useDropdownContext as P, useDropdownStyle as C, DropdownContext as O } from "../Dropdown.context.es.js";
const A = ({
  __css: n,
  children: s,
  contentStyles: i,
  initialFocus: _,
  returnFocus: o,
  ...r
}) => {
  const {
    activeIndex: l,
    context: a,
    elementsRef: c,
    floatingStyles: p,
    getFloatingProps: d,
    getItemProps: m,
    isNested: F,
    onOpen: f,
    isOpen: t,
    labelsRef: g,
    refs: u,
    setActiveIndex: x,
    setHasFocusInside: v
  } = P(), h = C();
  return /* @__PURE__ */ e(
    O.Provider,
    {
      value: {
        activeIndex: l,
        setActiveIndex: x,
        getItemProps: m,
        setHasFocusInside: v,
        open: t,
        setOpen: f
      },
      children: /* @__PURE__ */ e(y, { elementsRef: c, labelsRef: g, children: t && /* @__PURE__ */ e(D, { children: /* @__PURE__ */ e(
        I,
        {
          context: a,
          initialFocus: -1,
          returnFocus: o !== void 0 ? o : !F,
          children: /* @__PURE__ */ e(
            w,
            {
              ...r,
              __css: { ...h.content, ...n, ...i },
              ref: u.setFloating,
              style: p,
              ...d(),
              children: s
            }
          )
        }
      ) }) })
    }
  );
};
export {
  A as DropdownContent
};
//# sourceMappingURL=DropdownContent.es.js.map
